import React from 'react'
import _ from 'lodash'

const CONVERTER = {
  DEFAULT: {
    toStorage: _.identity,
    fromStorage: _.identity,
  },
  BOOLEAN: {
    toStorage: (value) => {
      return value.toString()
    },
    fromStorage: (value) => {
      return value === 'true' ? true : value === 'false' ? false : undefined
    },
  },
}

const NONE_STORAGE = {
  getItem: _.noop,
  setItem: _.noop,
  removeItem: _.noop,
}

const getSafeOptions = (options) => {
  return _.isObject(options) ? options : { defaultValue: options }
}

const getItem = (storage, key, oldKey) => {
  let item = storage.getItem(key)
  if (!item && oldKey) {
    // Retrieve and remove item from old storage key
    item = storage.getItem(oldKey)
    storage.removeItem(oldKey)
  }
  return item
}

const useStateWithStorage = (storageType, storageKey, options) => {
  const storage = !storageKey ? NONE_STORAGE : storageType === 'session' ? sessionStorage : localStorage

  const { defaultValue, oldStorageKey } = getSafeOptions(options)
  const { toStorage, fromStorage } = _.isBoolean(defaultValue) ? CONVERTER.BOOLEAN : CONVERTER.DEFAULT

  const [value, setValue] = React.useState(() =>
    _.defaultTo(getItem(storage, storageKey, oldStorageKey), toStorage(defaultValue)),
  )

  const handleValueChange = React.useCallback((newValue) => setValue(toStorage(newValue)), [toStorage])

  React.useEffect(() => {
    if (_.isNil(value)) {
      storage.removeItem(storageKey)
    } else {
      storage.setItem(storageKey, value)
    }
  }, [storage, storageKey, value])

  return [fromStorage(value), handleValueChange]
}

export default useStateWithStorage
